AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "LogEntry");

AoPS.Alcumus.Models.LogEntry = (function () {
	// Dependencies
	var AlcMBase = AoPS.Alcumus.Models.Base;

	return AlcMBase.BaseModel.extend({
		defaults: {
			agent_user_id: 0,
			agent_username: "",
			type: "",
			happened_at: null,
			data: {},
		},
		/** Additional attributes:
			user: User model owning this one; guaranteed to be set
		*/

		createFriend: function () {
			var data = _.clone(this.get("data"));
			var field = data.accepted ? "friends" : "friend_requests_me";
			data.user_id = data.other_user_id;
			this.get("user").createStubFriend(field, data);
		},

		unpack: function (data) {
			if (!data) {
				return;
			}

			this.setFields(data);
			if (data.type === "friend_status") {
				this.createFriend();
			}
		},

		isValid: function () {
			var type = this.get("type");

			if (
				(type === "class_nag" || type === "focus_changed") &&
				!this.isValidFocusEntry()
			) {
				return false;
			}

			return true;
		},

		isValidFocusEntry: function () {
			var focus_keys = ["old_focus", "new_focus", "due_focus", "overdue_focus"];
			return _.all(
				focus_keys,
				function (key) {
					var focus_data = this.get("data")[key];
					return !focus_data || this.getFocusAsModels(focus_data);
				},
				this
			);
		},

		isMe: function () {
			return this.get("agent_user_id") === this.get("user").id;
		},

		getUserUrlId: function () {
			return this.isMe() ? "me" : this.get("agent_user_id");
		},

		getShownUsername: function () {
			return this.isMe() ? "YOU" : this.get("agent_username");
		},

		getEventTime: function () {
			if (!this.get("happened_at")) {
				return "";
			}
			return this.get("happened_at");
		},

		// Internal helper function for the getX methods below.
		getUserObject: function (coll_name, id_value) {
			if (id_value === "" || id_value <= 0) {
				return null;
			}
			return this.get("user").get(coll_name).get(id_value);
		},

		// id_value optional for all of the below getX methods;
		// defaults to id given in data.

		getUser: function (id_value) {
			id_value = id_value || this.get("data").other_user_id;
			return this.get("user").get("master").getUser(id_value);
		},

		getSubject: function (id_value) {
			id_value = id_value || this.get("data").subject_id;
			return this.getUserObject("subjects", id_value);
		},

		getClass: function (id_value) {
			id_value = id_value || this.get("data").class_id;
			return this.getUserObject("classes", id_value);
		},

		getTopic: function (id_value) {
			id_value = id_value || this.get("data").topic_id;
			return this.getUserObject("topics", id_value);
		},

		getAstat: function (id_value) {
			id_value = id_value || this.get("data").astat_id;
			return this.getUserObject("astats", id_value);
		},

		getTrial: function (id_value) {
			id_value = id_value || this.get("data").trial_id;
			return this.getUserObject("trials", id_value);
		},

		getQuest: function () {
			var data = this.get("data");
			var quest = this.getUserObject("quests", data.quest_id);
			return (
				quest &&
				quest.get("levels").findWhere({user_quest_id: data.user_quest_id})
			);
		},

		isNewFocusDifferent: function () {
			return !_.isEqual(this.get("data").old_focus, this.get("data").new_focus);
		},

		// Returns [topic model, parent model], given an object with
		// return format of user model's getFocusAsObject.
		// Return follows the format of focus_topic, focus_parent in user model.
		getFocusAsModels: function (focus) {
			return this.get("user").getFocusAsModels(focus);
		},
	});
})();
